import { pxToRemUnit } from './px-to-rem.js';

const SELECTOR = '.filters-form--inline';
const ITEM_SELECTOR = '.filter-tag';

const equalizeInlineFilters = {
    resizeBound: false,

    init() {
        this.refresh();

        if (this.resizeBound) {
            return;
        }

        this.resizeBound = true;

        window.addEventListener('resize', () => {
            this.refresh();
        });
    },

    refresh(root = document) {
        const scope = root instanceof Element || root instanceof Document ? root : document;
        const forms = scope.matches?.(SELECTOR)
            ? [scope]
            : Array.from(scope.querySelectorAll(SELECTOR));

        forms.forEach((form) => {
            const tags = Array.from(form.querySelectorAll(ITEM_SELECTOR));

            if (!tags.length) {
                return;
            }

            tags.forEach((tag) => {
                tag.style.minWidth = '';
            });

            const widestTag = Math.max(...tags.map((tag) => tag.offsetWidth));

            tags.forEach((tag) => {
                tag.style.minWidth = pxToRemUnit(widestTag);
            });
        });
    },
};

export default equalizeInlineFilters;
